import styled from 'styled-components'
// themes
import colors from 'themes/colors'
// components
import { HoverablePopover as HoverablePopoverOrigin } from 'components/UI'

export const MenuItem = styled.div`
  cursor: pointer;
  font-size: 16px;
  padding: 8px 4px;

  &:not(:last-child) {
    border-right: 2px solid ${colors.gray200};
    padding-right: 8px;
  }

  &:not(:first-child) {
    padding-left: 8px;
  }
`

export const HoverablePopover = styled((props) => <HoverablePopoverOrigin {...props} />)`
  div:first-child {
    padding-left: 8px;
  }
  div:last-child {
    padding-right: 12px;
  }
`
